<template>
  <div @click="setWeekday" class="weekday-item-component d-flex align-center" :class="{'active': isActive}">
    <div v-if="false" class="d-flex align-center justify-space-between fullwidth">
      <span class="weekday-label">{{ getWeekName }}</span>
    </div>
    <div v-if="true" class="d-flex align-center justify-space-between fullwidth">
      <span class="weekday-label">{{ weekday }}</span>
      <span class="weekday-label">{{ getWeekName }}</span>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'WeekDayItem',
    props: {
      isActive: Boolean,
      weekday: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        weekDays: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
      }
    },
    computed: {
      getWeekName () {
        if (this.weekday) {
          return moment(this.weekday, 'DD.MM.YYYY').locale('ru').format('dddd')
        }
        return ''
      },
    },
    methods: {
      setWeekday () {
        this.$emit('update-weekday', this.weekday)
      },
    },
  }
</script>

<style lang="less" scoped>
  .weekday-item-component {
    height: 94px;
    width: 100%;
    padding: 26px 19px 26px 21px;
    margin-bottom: 15px;
    background-color: #F1F3F6;
    border-radius: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &.active {
      background-color: @color-primary;
      .weekday-label {
        color: #ffffff;
      }
    }

    .weekday-label {
      font-size: 24px;
      line-height: 1;
      transition: color 0.2s ease;
      text-transform: capitalize;
    }

    // компактный десктоп: дни ниже, чтобы все шесть и кнопка «Как можно скорее»
    // помещались на экран; шрифт меньше - дата и день недели слипались
    .media-compact-pc({
      height: 62px;
      // боковые поля 14px: на 1025px «05.10.2026» и «Понедельник» иначе встык
      padding: 0 14px;
      margin-bottom: 12px;

      .weekday-label {
        font-size: 20px;
      }
    });
  }
</style>
